import React, { useContext, useEffect, useState } from 'react';
import { Button, Footer, Input, Layout } from 'components';
import './reports.less';
import moment from 'moment';
import FileSaver  from 'file-saver';
import emptyReportImage from 'assests/images/empty-report.png';
import UploadIcon from 'assests/icons/upload.icon';
import { Table, DatePicker, Modal, Dropdown, Tooltip, Form, message } from 'antd';
import { DimensionsContext } from 'context/dimensions.context';
import classNames from 'classnames';
import SearchIcon from 'assests/icons/search.icon';
import PauseIcon from 'assests/icons/pause.icon';
import PlayIcon from 'assests/icons/play.icon';
import DotsMenuIcon from 'assests/icons/dots-menu.icon';
import ResendIcon from 'assests/icons/resend.icon';
import ExcelIcon from 'assests/icons/excel.icon';
import CloseIcon from 'assests/icons/close.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import { getCampaigns, getCampaignsDash, pauseCampaign, resumeCampaign,cancelCampaign,getRecreateCampaign, getReport,updateCampaignSendTime } from 'services/campaign.service';
import { useSelector } from 'react-redux';
import { customMessages } from 'utils';

import { useHistory } from 'react-router-dom';
import { DEFAULT_PAGE_SIZE } from 'constants/table.const';

import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useDebouncedCallback  } from 'use-debounce';
import {serverUrl } from '../../config';
import EditIcon from 'assests/icons/edit.icon';
import SelectDatePicker from 'components/Select/datepicker';
import * as infoService from 'services/info.service';
const ReportsPage = () => {
  
  const [form] = Form.useForm();
  const history = useHistory();
  const {user} = useSelector(state => state.auth);
  const [reportData, setReportData] = useState({});
  const [dashData, setDashData] = useState({});
  const [report, setReport] = useState('date');
  const [modalReportStatus, setModalReportStatus] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [dateRangeValue, setDateRangeValue] = useState('Son 1 Ay');
  const [dateRangeStartValue, setDateRangeStartValue] = useState( moment().subtract(1, 'months').format("yyyy-MM-DDTHH:mm:ss.SSS"));
  const [dateRangeEndValue, setDateRangeEndValue] = useState( moment().add(12, 'months').format("yyyy-MM-DDTHH:mm:ss.SSS"));

  const [pickerRangeValue, setPickerRangeValue] = useState([]);
  
  const [dateEditing, setDateEditing] = useState(false);
  
  const [rangeType, setRangeType] = useState('oneMonth');
  const [modalData, setModalData] = useState(null);
  const { isPc, isTabletBig } = useContext(DimensionsContext);
  const [currentPage, setCurrentPage] = useState(0);

  
  const [searchText, setSearchText] = useState('');
  const [startDate,setStartDate] = useState(null);
  
  const [startHour, setStartHour] = useState(9);
  const [endHour, setEndHour] = useState(21);
  const { RangePicker } = DatePicker;
  const reportsTableOptions = (
    <div className="reports-table-options">
      <button
        onClick={() => {
          setModalReportStatus(true);
        }}
      >
        Rapor Oluştur
      </button>
      <button>İptal Et</button>
    </div>
  );

  function reportMenu(record) {
    const {campaignStatus} = record;
    return (
      <div className="reports-table-options">
      <button
        onClick={() => {
          setModalData(record);
          setModalReportStatus(true);
        }}
      >
        Rapor Oluştur
      </button>
      {(campaignStatus === 'READY_TO_SEND' || campaignStatus === 'NEW' || campaignStatus === 'ACTIVE'  || campaignStatus === 'PAUSE')  &&

        <button onClick={() => OnCancelCampaign(record)}>İptal Et</button>
      }
    </div>
    );
  }

 

  const monthFormat = 'DD/MMMM';
  const columns = [
    {
      title: 'Kampanya',
      dataIndex: 'campaignName',
    },
    {
      title: 'Gönderim Zamanı',
      dataIndex: 'startDate',
      render: (text,record) => {
        return (
          moment(record.startDate).format("DD.MM.YYYY HH:mm")
        );
      }
    },
    {
      title: 'Durumu',
      dataIndex: 'campaignStatus',
      render: (text,record) => {
        return (
          customMessages.getMessage(text)
        );
      }
    },
    {
      title: 'Başarılı',
      dataIndex: 'deliveryCount',
    },
    {
      title: 'Başarısız',
      dataIndex: 'failCount',
    },
    {
      title: 'Devam eden',
      dataIndex: 'waitingCount',
    },
    {
      title: 'Harcanan Kredi',
      dataIndex: 'usedCredit',
    },
    {
      title: '',
      dataIndex: 'actions',
      render: (text, record) => {
        const { campaignStatus } = record;
        return (
          <div
            className={classNames({
              active: campaignStatus === 'READY_TO_SEND' || campaignStatus === 'NEW' || campaignStatus === 'ACTIVE' || campaignStatus === 'PAUSE',
            })}
          >
            {(campaignStatus === 'READY_TO_SEND' || campaignStatus === 'NEW' || campaignStatus === 'ACTIVE') ? (
              <button onClick={()=> OnPauseCampaign(record)}>
                <PauseIcon />
              </button>
            ) : null}
            {campaignStatus === 'PAUSE' ? (
              <button  onClick={(e)=>OnResumeCampaign(record)}>
                <PlayIcon />
              </button>
            ) : null}
            {(campaignStatus === 'FINISH' || campaignStatus === 'STOP') ? (
               <Tooltip title="Kampanyayı Yenile">
              <button onClick={(e)=> onResend(record.campaignId) }>
                <ResendIcon  />
              </button></Tooltip>
            ) : null}
            <Tooltip title="Gönderi İncele">
            <Dropdown
              className="menu-dropdown"
              overlay={reportMenu(record)}
              trigger={['click']}
              placement="bottomRight"
            > 
              <button>
                <DotsMenuIcon />
              </button>
            </Dropdown></Tooltip>
          </div>
        );
      },
    },
  ];
  const tabletColumns = [
    {
      title: 'Kampanya',
      dataIndex: 'campaignName',
    },
    {
      title: 'Gönderim Zamanı',
      dataIndex: 'startDate',
      render: (text,record) => {
        return (
          moment(record.startDate).format("DD.MM.YYYY")
        );
      }
    },
    {
      title: 'Durumu',
      dataIndex: 'campaignStatus',
      render: (text,record) => {
        return (
          customMessages.getMessage(text)
        );
      }
    },
    {
      title: 'Başarılı',
      dataIndex: 'deliveryCount',
    },
    {
      title: 'Başarısız',
      dataIndex: 'failCount',
    },
    {
      title: 'Devam eden',
      dataIndex: 'waitingCount',
    },
    {
      title: 'Harcanan Kredi',
      dataIndex: 'usedCredit',
    },
    {
      title: '',
      dataIndex: 'actions',
      fixed: 'right',
      width: isPc?  118:95,
      render: (products = [], record) => {
        const { campaignStatus } = record;
        return (
          <div
            className={classNames({
              active: campaignStatus === 'READY_TO_SEND' || campaignStatus === 'NEW' || campaignStatus === 'ACTIVE' || campaignStatus === 'PAUSE',
            })}
          >
            {(campaignStatus === 'READY_TO_SEND' || campaignStatus === 'NEW' || campaignStatus === 'ACTIVE') ? (
              <button>
                <PauseIcon />
              </button>
            ) : null}
            {campaignStatus === 'PAUSE' ? (
              <button>
                <PlayIcon />
              </button>
            ) : null}
            {campaignStatus === 'FINISH' ? (
              <Tooltip title="Kampanyayı Yenile">
                <button onClick={()=> onResend(record.campaignId) }>
                  <ResendIcon />
                </button> 
              </Tooltip>
            ) : null}
            <Dropdown
              className="menu-dropdown"
              overlay={reportMenu(record)}
              trigger={['click']}
              placement="bottomRight"
            >
              <button>
                <DotsMenuIcon />
              </button>
            </Dropdown>
          </div>
        );
      },
    }
  ];
 
  const changeReportDateRangeValue = (e) => {
    setDateRangeStartValue(moment().subtract(e, 'months').format("yyyy-MM-DDTHH:mm:ss.SSS"));
    setDateRangeEndValue(moment().add(3, 'months').format("yyyy-MM-DDTHH:mm:ss.SSS"));
   
    setPickerRangeValue([]);
    
  };


  const dateRangeMobile = (
    <div className="date-range-mobile__options">
      <span onClick={()=>{changeReportDateRangeValue(1);setRangeType("oneMonth");}}>Son 1 Ay</span>
      <span onClick={()=>{changeReportDateRangeValue(3);setRangeType("threeMonth");}}>Son 3 Ay</span>
      <span onClick={()=>{changeReportDateRangeValue(12);setRangeType("oneYear");}}>Son 1 Yıl</span>
      <span
        onClick={() => {
          setPickerOpen(true);
        }}
      >
        Tarih Aralığı Seç
      </span>
    </div>
  );


  const OnPauseCampaign = (campaign) => {
    pauseCampaign({campaign:campaign}).then((res) => {
      getReportData(currentPage,searchText);
    }).catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  };

  const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  const OnCreateReport = (id) => {
    getReport(id).then((res) => {
      const blob=  b64toBlob(res,'application/vnd.ms-excel');
     
     FileSaver.saveAs(blob, 'Gonderim-'+id+'.xlsx');
    }).catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  };

  const OnResumeCampaign = (campaign) => {
    resumeCampaign({campaign:campaign}).then((res) => {
      getReportData(currentPage,searchText);
    }).catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  };

  const OnCancelCampaign = (campaign) => {
    cancelCampaign({campaign:campaign}).then((res) => {
      getReportData(currentPage,searchText);
    }).catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  };

  const getReportData= (current=currentPage,search='') => {
   
    getCampaigns({startDate:dateRangeStartValue,endDate:dateRangeEndValue,search,size:DEFAULT_PAGE_SIZE,page:current,sort:'-scheduleTime'}).then((res) => {
      setReportData(res);
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

   
  const delayedOnValuesChange = useDebouncedCallback(
    // function
    (e) => {
      setSearchText(e);
      getReportData(currentPage,e);
    },
    // delay in ms
    300
  );


  const getDashData= () => {
    getCampaignsDash({startDate:dateRangeStartValue,endDate:dateRangeEndValue,sort:'-startDate'}).then((res) => {
      setDashData(res);
      getReportData(currentPage,searchText);
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  }

  const onTableChange = (pagination, filters, sorter, extra) => {
    var current = pagination.current-1;
    setCurrentPage(current);
    getReportData(current,searchText);
  };

  const onSelectedChage = (e) => {
    setStartDate(e);
  }

  const onResend = (campaignId) => {
    getRecreateCampaign(campaignId).then((result) => {
     let data = result.campaign;
      data.messageText = data.message;
      history.push('/NewMessage', {messageData:data});
    }).catch((err) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(err.responseCode),
      });
    });
  };


  const onEditSendDate = () =>
  {
    if (startDate)
    {

   
    updateCampaignSendTime(modalData?.campaignId,startDate.valueOf()).then((result) => {     
       setDateEditing(false);
       setModalReportStatus(false);
       getDashData();
     }).catch((err) => {
       var message = customMessages.getMessage(err.responseCode).replace("{startHour}", startHour).replace("{endHour}", endHour);
       Modal.error({
         title: 'Hata',
         content: message
       });
       return;
     });
    }
    setDateEditing(false);
    setModalReportStatus(false);
  }

  useEffect(() => {      
      getDashData();    
  }, [dateRangeStartValue,dateRangeEndValue]);

  useEffect(() => {
    if (dateEditing)
    {
      infoService.getWorkingHours().then((result) => {
        setStartHour(result.properties.startHour);
        setEndHour(result.properties.endHour);
      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
    }
  }, [dateEditing])

  return (
    <Layout>
      <div className="reports-page">
        <div className="container">
          <h1 className="section__title">Raporlar</h1>
          {report === 'empty' ? (
            <div className="box report-empty">
              <figure>
                <img src={emptyReportImage} alt="Empty Report Image" />
              </figure>
              <strong className="section__sub-title">
                Henüz kayıtlı ünvanınız bulunmuyor.
              </strong>
              <p className="info-text--big">
                Mesaj kampanyaları düzenleyebilmek için şirket ünvanınızı
                sisteme ekleyip doğrulayın, müşteirlerinize mesaj göndermeye
                başlayın.
              </p>
              <Button type="primary" shape="round">
                Ünvan Tanımlamaya Başla
              </Button>
            </div>
          ) : (
            <>
              {isPc ? (
                <div className="date-range">
                  <div className={"date-range__item " + (rangeType=='oneMonth' ? 'active' : '')} onClick={()=>{changeReportDateRangeValue(1);setRangeType("oneMonth");}}>Son 1 Ay</div>
                  <div className={"date-range__item " + (rangeType=='threeMonth' ? 'active' : '')} onClick={()=>{changeReportDateRangeValue(3);setRangeType("threeMonth");}}>Son 3 Ay</div>
                  <div className={"date-range__item " + (rangeType=='oneYear' ? 'active' : '')} onClick={()=>{changeReportDateRangeValue(12);setRangeType("oneYear");}}>Son 1 Yıl</div>
                  <div className="date-range__item">
                    <RangePicker
                      format={monthFormat}
                      value={pickerRangeValue}
                      defaultValue={pickerRangeValue}
                      dropdownClassName="date-range_dropdown"
                      separator="&nbsp;-&nbsp;"
                      placeholder={['Başlangıç', 'Bitiş']}
                      suffixIcon={false}
                      onChange={(e) => {
                        setPickerRangeValue(e);
                        setDateRangeStartValue(moment(e[0]._d).format("yyyy-MM-DDTHH:mm:ss.SSS"));
                        setDateRangeEndValue(moment(e[1]._d).format("yyyy-MM-DDTHH:mm:ss.SSS"));
                        setRangeType("custom");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="date-range-mobile">
                    <Dropdown
                      overlayClassName="date-range-mobile__overlay"
                      overlay={dateRangeMobile}
                      trigger={['click']}
                      placement="bottomRight"
                    >
                      <span>
                        {dateRangeStartValue && dateRangeEndValue ? (
                          <>
                            {moment(dateRangeStartValue,"yyyy-MM-DDTHH:mm:ss.SSS").format("DD/MM/YYYY")} - {moment(dateRangeEndValue,"yyyy-MM-DDTHH:mm:ss.SSS").format("DD/MM/YYYY")}
                          </>
                        ) : (
                          dateRangeValue
                        )}{' '}
                        <DownChevronIcon />
                      </span>
                    </Dropdown>
                    <RangePicker
                      open={pickerOpen}
                      format={monthFormat} 
                      value={pickerRangeValue}
                      defaultValue={pickerRangeValue}
                      className="date-range-mobile__input"
                      onChange={(e) => {
                       setPickerRangeValue(e);
                        setDateRangeStartValue(moment(e[0]._d).format("yyyy-MM-DDTHH:mm:ss.SSS"));
                        setDateRangeEndValue(moment(e[1]._d).format("yyyy-MM-DDTHH:mm:ss.SSS"));
                        setPickerOpen(false);
                        setRangeType("custom");
                      }}
                      dropdownClassName="date-range_dropdown"
                      separator="&nbsp;-&nbsp;"
                      placeholder={['Başlangıç', 'Bitiş']}
                      suffixIcon={false}
                    />
                  </div>
                </>
              )}
              <div className="box">
                <div className="report-summary">
                  <div>
                    <div className="report-summary__row">
                      <div className="report-summary__row__item">
                        <strong>{dashData.totalCount ? dashData.totalCount.toLocaleString('tr-TR') :'0'}</strong>
                        <span>Toplam Gönderim</span>
                      </div>
                      <div className="report-summary__row__item">
                        <strong>{dashData.totalSuccess ? dashData.totalSuccess.toLocaleString('tr-TR'):'0'}</strong>
                        <span>Başarılı Gönderim</span>
                      </div>
                      <div className="report-summary__row__item">
                        <strong>{dashData.totalCost ? dashData.totalCost.toLocaleString('tr-TR'):'0'}</strong>
                        <span>Harcanan Kredi</span>
                      </div>
                    </div>
                    <div className="report-summary__row--v2">
                      <div className="report-summary__row__item">
                        <span className="title">SMS</span>
                        <strong>{dashData.smsSuccess ? dashData.smsSuccess.toLocaleString('tr-TR'):'0'}</strong>
                        <span>Başarılı Gönderim</span>
                        <span className="amount">
                          <strong>{dashData.smsSuccessCost ? dashData.smsSuccessCost.toLocaleString('tr-TR'):'0'}</strong> Kredi
                        </span>
                      </div>
                      <div className="report-summary__row__item">
                        <span className="title">Kişiye Özel SMS</span>
                        <strong>{dashData.paramSuccess ? dashData.paramSuccess.toLocaleString('tr-TR'):'0'}</strong>
                        <span>Başarılı Gönderim</span>
                        <span className="amount">
                          <strong>{dashData.paramSuccessCost ? dashData.paramSuccessCost.toLocaleString('tr-TR'):'0'}</strong> Kredi
                        </span>
                      </div>
                      <div className="report-summary__row__item">
                        <span className="title">Zengin İçerikli Mesaj</span>
                        <strong>{dashData.mmsSuccess?dashData.mmsSuccess.toLocaleString('tr-TR'):'0'}</strong>
                        <span>Başarılı Gönderim</span>
                        <span className="amount">
                          <strong>{dashData.mmsSuccessCost? dashData.mmsSuccessCost.toLocaleString('tr-TR'):'0'}</strong> Kredi
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="new-campaign">
                    <UploadIcon />
                    <span>Yeni bir kampanya oluşturmak ister misiniz?</span>
                    <NavLink to="/NewMessage" >
                      <Button type="primary" shape="round">
                      Mesaj Oluştur
                    </Button></NavLink>
                  </div>
                </div>
                <div className="group-members__search">
                  <Input 
                    prefix={<SearchIcon />}
                    placeholder="Rapor adı..."
                    autoComplete="off"
                    style={{ width: '100%' }} 
                    onChange={(e) => delayedOnValuesChange(e.target.value)}
                  />
                  <span className="group-members__items">
                    <strong>{reportData.totalCount}</strong> Rapor Görüntüleniyor
                  </span>
                </div>
               
                      <Table
                      key="campaignId"
                        columns={isTabletBig ? columns :  tabletColumns}
                        scroll={{ y: 610 }}
                        onChange={onTableChange}
                        dataSource={reportData.campaigns}
                        className= {reportData.totalCount>DEFAULT_PAGE_SIZE ? "table--report table--guide" : "table--report table--guide  pagination--false"}
                        pagination={{ total: reportData.totalCount, pageSize:DEFAULT_PAGE_SIZE, position: ['bottomCenter'] }}
                      />
                   
               
                <Modal
                  title={modalData?.campaignName}
                  className="ant-modal--reports-status"
                  width={670}
                  closeIcon={<CloseIcon />}
                  visible={modalReportStatus}
                  onCancel={() => setModalReportStatus(false)}
                  footer={null}
                >
                  <div className="modal--report-status">
                    <div className="content">
                      <div>
                        <strong>İlerleme</strong>
                        <span>{customMessages.getMessage(modalData?.campaignStatus)}</span>
                      </div>
                      <div>
                        <strong>Toplam Gönderim</strong>
                        <span>{modalData?.submitCount}</span>
                      </div>
                      <div>
                        <strong>Başarılı Gönderim</strong>
                        <span>{modalData?.deliveryCount}</span>
                      </div>
                      <div>
                        <strong>Başlangıç Saati</strong>



                        <span> {moment(modalData?.startDate).format("DD.MM.YYYY")} - {moment(modalData?.startDate).format("HH:mm")}
                        
                        {(modalData?.campaignStatus === 'READY_TO_SEND' ||   modalData?.campaignStatus === 'NEW') && 
                         <button style={{color: '#3fb0e8',
                          background: '#fff',
                          border: 'none',
                          padding: '8px'}}
                         onClick={() => setDateEditing(true)}
                         type="button"
                       >
                      <EditIcon  width={20} height={20}/>
                       </button>}
                        </span> 
                        
                    
                      </div>
                      <div>
                        <strong>Harcanan Kredi</strong>
                        <span>{modalData?.usedCredit}</span>
                      </div> 
                      {modalData?.sender && <div>
                        <strong>Ünvan</strong>
                        <span>{modalData?.sender}</span>
                      </div>} <div>
                        <strong>Mesaj Türü</strong>
                        <span>{modalData?.msgTypeStr}</span>
                      </div>
                      {modalData?.message && 
                      <div style={{width:'100%'}}>
                        <strong>Mesaj</strong>
                        <span>{modalData?.message}</span>
                      </div>
                      }
                    </div>
                    <div className="modal-action">
                     
                     
                      <button onClick={() =>  OnCreateReport( modalData?.campaignId)} type="link"  >
                        <ExcelIcon /> Rapor Oluştur
                      </button> 
                      {(modalData?.campaignStatus === 'READY_TO_SEND' || modalData?.campaignStatus === 'NEW' || modalData?.campaignStatus === 'ACTIVE')  &&

                      <Button
                        shape="round"
                        type="ghost"
                        onClick={() => {
                          OnPauseCampaign(modalData);
                          setModalReportStatus(false)
                        }}
                      >
                        <PauseIcon />
                        Duraklat
                      </Button>
                        }
                         {(modalData?.campaignStatus === 'READY_TO_SEND' || modalData?.campaignStatus === 'NEW' || modalData?.campaignStatus === 'ACTIVE'  || modalData?.campaignStatus === 'PAUSE')  &&

                      <Button
                        shape="round"
                        type="ghost"
                        className="ant-btn-ghost--red"
                        onClick={() => {
                          OnCancelCampaign(modalData);
                          setModalReportStatus(false);
                        }}
                      >
                        <CloseIcon />
                        İptal Et
                      </Button>
}
                    </div>
                  </div>
                </Modal>
{dateEditing && 
                <Modal   title={modalData?.campaignName}
                  className="ant-modal--reports-status"
                  width={670}
                  closeIcon={<CloseIcon />}
                  visible={dateEditing}
                  onCancel={() => setDateEditing(false)}
                  footer={null}>
                     <Form
          form={form}
          name="choose-title"
        >
                <SelectDatePicker
                       defaultValue={moment(modalData?.startDate)}
                         formName="clock"
                         hours
                         onChange={onSelectedChage}
                         hourStart={startHour}
                         hourEnd={endHour}
                       />
                       {(modalData?.campaignStatus === 'READY_TO_SEND' ||   modalData?.campaignStatus === 'NEW') && 
                         <Button
                         shape="round"
                         type="ghost"
                         onClick={() =>  onEditSendDate() }
                       >
                       Güncelle
                       </Button>}</Form>
                </Modal>}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default ReportsPage;
